/**
 * @generated SignedSource<<1aa535e05b8f889466c224df0e6ec85e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopyLinkButton_node$data = {
  readonly canonicalUrl?: URIString;
  readonly " $fragmentType": "CopyLinkButton_node";
};
export type CopyLinkButton_node$key = {
  readonly " $data"?: CopyLinkButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"CopyLinkButton_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CopyLinkButton_node",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalUrl",
          "storageKey": null
        }
      ],
      "type": "HasCanonicalUrlInterface",
      "abstractKey": "__isHasCanonicalUrlInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "d584188e1e89ed9f312dfbd2948ae3ce";

export default node;
